<template>
   <!-- <div class="col-sm-4 col-sm-offset-4">
     <h2>Log In</h2>
     <p>Log in to your account to get some great quotes.</p>
      <div class="alert alert-danger" v-if="error">
       <p>{{ error }}</p>
     </div>
     <div class="form-group">
       <input
         type="text"
         class="form-control"
         placeholder="Enter your username"
         v-model="credentials.user_login"
       >
     </div>
     <div class="form-group">
       <input
         type="password"
         class="form-control"
         placeholder="Enter your password"
         v-model="credentials.user_password"
       >
     </div>
     <button class="btn btn-primary" @click="submit()">Access</button>
   </div>  -->

    <div class="login-container">
<!-- 
   <el-form :model="credentials" :rules="rules" ref="credentials"  >
  <el-form-item label="User Name" prop="user_login":label-width="formLabelWidth">
    <el-input  size="mini" type="text" v-model="credentials.user_login"></el-input>
  </el-form-item>
    <el-form-item label="Password" prop="user_login":label-width="formLabelWidth">
    <el-input   placeholder = "password.." type="password" v-model="credentials.user_password"></el-input>
  </el-form-item>
  </el-form>
   <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="EditStudent()">Confirm</el-button>
  </span -->

        <el-form autoComplete="on" :model="credentials" :rules="rules" label-position="left"
                 label-width="0px"
                 class="card-box login-form">
            <h3 class="title">Teacher Login</h3>
            <el-form-item prop="user_login">
                <!-- <span class="svg-container"><wscn-icon-svg icon-class="jiedianyoujian"/></span> -->
                <el-input name="email" type="text" v-model="credentials.user_login" autoComplete="on"
                          placeholder="Login Name"></el-input>
            </el-form-item>
            <el-form-item prop="user_password">
                <!-- <span class="svg-container"><wscn-icon-svg icon-class="mima"/></span> -->
                <el-input name="password" type="password" @keyup.enter.native="submit" v-model="credentials.user_password"
                          autoComplete="on" placeholder="密码:Password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width:100%;"  @click.native.prevent="submit">
                    Login
                </el-button>
            </el-form-item>
 <!--            <div class='tips'>admin账号为:admin@wallstreetcn.com 密码随便填</div>
            <div class='tips'>editor账号:editor@wallstreetcn.com 密码随便填</div>
            <router-link to="/sendpwd" class="forget-pwd">
                忘记密码?(或首次登录)
            </router-link> -->
        </el-form>

      </div>
 
 </template>
 

 <script>
  import auth from '../auth'
    import axios from 'axios';
 // var sjcl = require('../auth/sjcl.js');
  //var pako = require('pako');

  export default {
    data() {
      return {
  //    user: auth.user,
      teacher: auth.teacher,
//      teacher_name: auth.teacher_name,
            formLabelWidth: '120px',

        credentials: {
          user_login: '',
          user_password: ''
        },
               rules: {
          user_login: [
            { required: true, message: 'Please User name', trigger: 'blur' },
            { min: 5, message: 'Length should be more than 5 chars', trigger: 'blur' }
          ] ,
           user_password: [
            { required: true, message: 'Please Password', trigger: 'blur' },
            { min: 5, message: 'Length should be more than 5 chars', trigger: 'blur' }
          ] },
        error: ''
      }
    },
    methods: {
myEncrypt( s, k ){
		var enc = "";
		var str = "";
		// make sure that input is string
		str = s.toString();
		for (var i = 0; i < s.length; i++) {
			// create block
			var a = s.charCodeAt(i);
			// bitwise XOR
			var b = a ^ k;
			enc = enc + String.fromCharCode(b);
		}
		return enc;


},

// Equivilent to PHP bin2hex
 


      submit() {
        var _this=this;
  //      console.log('dog');
 /*        var tmp =sjcl.encrypt("Coco!!123", this.credentials.user_login);
        var cipherlogin =encodeURI(JSON.stringify(tmp));
        var cipherpass =encodeURI(JSON.stringify(sjcl.encrypt("Coco!!123", this.credentials.user_password)));
 */
        var credentials = {
//          user_login: this.credentials.user_login,
 //         user_password: this.credentials.user_password
          doit:   this.credentials.user_login,
     //     haha: encodeURI(JSON.stringify(sjcl.encrypt("Co123", 'teacher'))),
          doitright: this.credentials.user_password
        }
      //   auth.login_or_signup('login', this, credentials, 'family');

//var plaintext = sjcl.decrypt("Coco!!123", JSON.parse(decodeURI(cipherlogin)));

         
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


var key = "123"; // only work with simple number, be careful if try with new key. bad function.
/* 
var params = new URLSearchParams();
params.append( 'doit',   this.myEncrypt(this.credentials.user_login,key));
params.append('doitright', this.myEncrypt(this.credentials.user_password,key));
 */ 

//console.log('cre',this.myEncrypt(this.credentials.user_login,key));
    this.teacher.token_time= new Date().getTime();  // store init token time.
//console.log('this.teacher.token_time', this.teacher.token_time);
var inputs = { doit:this.myEncrypt(this.credentials.user_login,key), doitright:this.myEncrypt(this.credentials.user_password,key) }
//var inputs = { doit:this.myEncrypt(this.credentials.user_login,key), doitright:this.myEncrypt(this.credentials.user_password,key) }

/*
 So frustrated.: 
 1. post, doesn't work with Godaddy PHP db, so need to use put instead. My mac mysql worked fine with post.
 2. another reason, want to use URLSearchParams, but IOS or MAc os doesn't support URLSearchParams
 so force me to use this trick with put .
*/
       axios.put(this.$API_url + '/lastday1/' + 10, inputs )
      .then((response) => {

      localStorage.setItem('teach_token', response.data.id_token)
  //console.log('token', response.data.id_token);

    //  var list =  JSON.parse(sjcl.decrypt("Coco!!123", decodeURI( response.data.data)));
      var list =  response.data ;
         //   console.log('dogdog', list);
      _this.teacher.teacher_info = list; 
       _this.teacher.teacher_id = list.teacher_id;
       _this.teacher.teacher_name = list.teacher_fname + ' ' + list.teacher_lname;
                //   console.log ('response teacher id',_this.teacher.teacher_id,  'teacher_name ',_this.teacher.teacher_name, '  token ' ,response.data.id_token, );

  // console.log('list',list);
/*       if (list.email2 == 'Report') {      // teacher and can access all attendance classes.
        _this.teacher.attendance = true;  
        _this.teacher.authenticated = true;  
        _this.$router.push({path: '/attendance'})
      }
      else  */
      if (list.email2 == 'ReportOnly')  {  // reporter read-only all attendance classes.
    //    _this.teacher.attendance = true;  
           this.$message.error('User Prohibited!!');    
    //   _this.$router.push({path: '/report_attendance'})
      }
      else {                                            // teacher only can access their own classes.
       _this.teacher.authenticated = true;  
        _this.$router.push({path: '/attendance'})
      }

      }).catch((err) => {
     // console.log('in error', err.response.data)
        var statusCode =err.response.data.statusCode,  message = err.response.data.message;
         if (  statusCode == 401)
          this.$message.error(message);      
         if (  statusCode == 422)
          this.$message.error(message);           
      })

   
           
       
      }

    }
  }
 </script>

<style rel="stylesheet/scss" lang="scss">
    @import "src/styles/mixin.scss";
    .tips{
      font-size: 14px;
      color: #fff;
      margin-bottom: 5px;
    }
    .login-container {
        @include relative;
        height: 100vh;
        background-color: #2d3a4b;

        input:-webkit-autofill {
            -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
            -webkit-text-fill-color: #fff !important;
        }
        input {
            background: transparent;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            padding: 12px 5px 12px 15px;
            color: #eeeeee;
            height: 47px;
        }
        .el-input {
            display: inline-block;
            height: 47px;
            width: 85%;
        }
        .svg-container {
            padding: 6px 5px 6px 15px;
            color: #889aa4;
        }

        .title {
            font-size: 26px;
            font-weight: 400;
            color: #eeeeee;
            margin: 0px auto 40px auto;
            text-align: center;
            font-weight: bold;
        }

        .login-form {
            position: absolute;
            left: 0;
            right: 0;
            width: 400px;
            padding: 35px 35px 15px 35px;
            margin: 120px auto;
        }

        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            color: #454545;
        }

        .forget-pwd {
            color: #fff;
        }
    }

</style>



// WEBPACK FOOTER //
// Teacher_Login.vue?2d55c3b2